import React from 'react';
import ConnectedManagedOrganizationList from '../containers/ConnectedManagedOrganizationList';

const RelatedOrganizations = () => {
  return <ConnectedManagedOrganizationList />;
};

export default RelatedOrganizations;
